import { defineStore } from 'pinia';
import { useKeycloakStore } from './keycloak.js';

export const useInvitationStore = defineStore('invitation', {
  state: () => ({
    invitee: '',
    invitationList: [],
    invitation: '',
  }),
  persist:true,

  actions: {
    async createNewInvitation(payload) {
      const { default: axios } = await import('axios');
      const path = `${import.meta.env.VITE_APP_URL}invitation`;
      try {
        const { data } = await axios.post(path, payload, {
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.invitation = data;
        this._updateInvitationList(data);
      } catch (err) {
        console.log(err);
      }
    },

    async getInvitation(payload) {
      const { default: axios } = await import('axios');
      const path = `${import.meta.env.VITE_APP_URL}invitation`;
      try {
        const { data } = await axios.get(path, {
          params: { invitationId: payload },
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.invitation = data;
      } catch (err) {
        console.log(err);
      }
    },

    async getGroupInvitationList(payload) {
      const { default: axios } = await import('axios');
      const path = `${import.meta.env.VITE_APP_URL}invitation`;
      try {
        const { data } = await axios.get(`${path}/list`, {
          params: { entityId: payload.entityId, domainType: payload.domainType },
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.invitationList = data;
      } catch (err) {
        console.log(err);
      }
    },

    async updateInvitation(payload) {
      const { default: axios } = await import('axios');
      const path = `${import.meta.env.VITE_APP_URL}invitation`;
      try {
        const { data } = await axios.put(path, payload, {
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.invitation = data;
        this._updateInvitationList(data);
      } catch (err) {
        console.log(err);
      }
    },

    async acceptInvitation(payload) {
      const { default: axios } = await import('axios');
      const path = `${import.meta.env.VITE_APP_URL}invitation`;
      try {
        const { data } = await axios.put(`${path}/accept`, null, {
          params: { invitationId: payload.invitationId },
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.invitation = data;
        this._updateInvitationList(data);
      } catch (err) {
        console.log(err);
      }
    },

    async changeInvitationStatus(payload) {
      const { default: axios } = await import('axios');
      const path = `${import.meta.env.VITE_APP_URL}invitation`;
      try {
        const { data } = await axios.put(`${path}/status`, null, {
          params: {
            invitationId: payload.invitationId,
            userId: payload.userId,
            status: payload.status,
          },
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.invitation = data;
        this._updateInvitationList(data);
      } catch (err) {
        console.log(err);
      }
    },

    async deleteInvitation(payload) {
      const { default: axios } = await import('axios');
      const path = `${import.meta.env.VITE_APP_URL}invitation`;
      try {
        await axios.delete(path, {
          params: { invitationId: payload.invitationId, isAdmin: payload.isAdmin },
          headers: { Authorization: `Bearer ${useKeycloakStore().token}` },
        });
        this.invitationList = this.invitationList.filter(
          (item) => item.id !== payload.invitationId
        );
      } catch (err) {
        console.log(err);
      }
    },

    _updateInvitationList(invitation) {
      const index = this.invitationList.findIndex((item) => item.id === invitation.id);
      if (index === -1) {
        this.invitationList.push(invitation);
      } else {
        this.invitationList.splice(index, 1, invitation);
      }
    },
  },
});
